export default __webpack_public_path__ + "static/affiliate-program-AffiliateApp-1a09f3a80e759bf9555d0da9c2839962.png";